import type { FieldPath, FieldValues } from "react-hook-form";

import { FormTextField, type FormTextFieldProps } from "./form-text-field";
import { applyMask, isDigitMask } from "./mask";

export type FormMaskedTextFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<FormTextFieldProps<TFieldValues, TName>, "format" | "maxLength"> & {
  /** `#` a digit, `A` a letter, `*` either; every other character is a literal. */
  mask: string;
};

export const FormMaskedTextField = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  mask,
  keyboardType,
  ...textFieldProps
}: FormMaskedTextFieldProps<TFieldValues, TName>) => (
  <FormTextField<TFieldValues, TName>
    {...textFieldProps}
    // `phone-pad`, not `numeric`: on iOS `numeric` is the decimal pad, and a
    // digit mask has no use for its decimal key.
    keyboardType={keyboardType ?? (isDigitMask(mask) ? "phone-pad" : undefined)}
    maxLength={mask.length}
    format={(value) => applyMask(value, mask)}
  />
);

FormMaskedTextField.displayName = "FormMaskedTextField";
